import React, {Component} from 'react';

class PackageProductItem extends Component {

    render() {
        const { name } = this.props;

        return (
            <li> { name } </li>
        )
    }
}

export default PackageProductItem;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/PackageProductItem.js